module.exports = __webpack_public_path__ + "assets/14.jpg?b059ddbbd625a452e07fc2b6c3e931a4";